// import {
//   SUBSCRIPTIONPLAN_CREATE_ACTIONS,
//   SUBSCRIPTIONPLAN_LIST_ACTIONS,
//   SUBSCRIPTIONPLAN_EDIT_ACTIONS,
//   SUBSCRIPTIONPLAN_DELETE_ACTIONS,
// } from "../../../actionsType";
// import { ADMIN_SUBSCRIPTIONPLAN_ACTIONS } from "../../../actionsType/admin/subscriptionPlan";

import { ADMIN_SUBSCRIPTIONPLAN_ACTIONS } from "../../../actionType/admin/subscriptionPlan";

const intialState = {
  subscriptionPlanCreatData: {},
  isSubscriptionPlanCreatLoader: false,
  subscriptionPlanList: [],
  isSubscriptionPlanListLoader: false,
  subscriptionPlanDeleteLoader: false,
  subscriptionPlanDeleteData: {},
};

export const adminSubscriptionPlanReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_REQUEST:
      return { ...state, isSubscriptionPlanCreatLoader: true };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_RESPONSE:
      return {
        ...state,
        subscriptionPlanCreatData: payload,
        isSubscriptionPlanCreatLoader: false,
      };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_ERROR:
      return {
        ...state,
        subscriptionPlanCreatData: payload,
        isSubscriptionPlanCreatLoader: false,
      };

    // SUBSCRIPTIONPLAN_LIST_ACTIONS

    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_LIST_REQUEST:
      return { ...state, isSubscriptionPlanListLoader: true };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_RESPONSE:
      return {
        ...state,
        subscriptionPlanList: payload,
        isSubscriptionPlanListLoader: false,
      };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_LIST_RESPONSE:
      return {
        ...state,
        subscriptionPlanList: payload,
        isSubscriptionPlanListLoader: false,
      };

    // SUBSCRIPTIONPLAN_EDIT_ACTIONS

    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_EDIT_REQUEST:
      return { ...state, isSubscriptionPlanCreatLoader: true };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_EDIT_RESPONSE:
      return {
        ...state,
        subscriptionPlanCreatData: payload,
        isSubscriptionPlanCreatLoader: false,
      };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_EDIT_ERROR:
      return {
        ...state,
        subscriptionPlanCreatData: payload,
        isSubscriptionPlanCreatLoader: false,
      };
    // SUBSCRIPTIONPLAN_DELETE_ACTIONS

    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_DELETE_REQUEST:
      return { ...state, subscriptionPlanDeleteLoader: true };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_DELETE_REQUEST:
      return {
        ...state,
        subscriptionPlanDeleteData: payload,
        subscriptionPlanDeleteLoader: false,
      };
    case ADMIN_SUBSCRIPTIONPLAN_ACTIONS.SUBSCRIPTIONPLAN_DELETE_ERROR:
      return {
        ...state,
        subscriptionPlanDeleteData: payload,
        subscriptionPlanDeleteLoader: false,
      };
    default:
      return state;
  }
};
